/**
 * App Component
 * @author PBirudukota
 */
import {Component, OnInit} from '@angular/core';
import {MessagesService} from './services/messages.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  showBackgroundImage: any;

  constructor(private messagesService: MessagesService) {

    this.messagesService.getBGMessage().subscribe(message => {
      this.showBackgroundImage = message.text;
    });

  }

  ngOnInit(): void {
  }

}
